const personalizationEngine = {
  personalizationEngine: {
    casino: 'Casino',
    sports: 'Sports',
    gameCategory: 'Game Category',
    gameProvider: 'Game Provider',
    favoriteGames: 'Favorite Games',
    totalTurnover: 'Total Turnover',
    turnover: 'Turnover',
    perc: 'Perc',
    gameId: 'Game Id',
  },
}

export default personalizationEngine
